import React, { ChangeEvent, useEffect, useState } from "react";
// import SlotType from "./Interfaces/SlotType";
import FormData from "./Interfaces/FormData";
import { baseAPIUrl } from "../../../Utils/BaseAPI";
import axios, { AxiosResponse } from "axios";
import DriverType from "./Interfaces/DriverInterface";
import { useNavigate, useParams } from "react-router-dom";
import { FieldExtractor } from "../../../Utils/field-extractor";
import { convertFirstLetterToLowerCase, getEnumKeys } from "../../../Utils/BaseUtils";
import BoxType from "./Interfaces/BoxType";
import ContainerConfigurationsType from "./Interfaces/ContainerConfigurationsType";

enum CategoryEnum {
    BALANCE = 'BALANCE',
    PRINTER = 'PRINTER',
    STRATEGY = 'STRATEGY'
}


interface DriverTypeProps {
    formData: DriverType;
    setFormData: React.Dispatch<React.SetStateAction<DriverType>>;
}

const CreateOrEdit: React.FC<DriverTypeProps> = ({formData, setFormData}) => {

    const navigate = useNavigate();

    const [data, updateData] = useState<any>();

    const categories = CategoryEnum;

    const { id } = useParams();
    const editAction = `${baseAPIUrl}GetDriver`;

    const [boxes, setBoxes] = useState<BoxType[]>([]);
    const [containerConfigurations, setContainerConfigurations] = useState<ContainerConfigurationsType[]>([]);

    useEffect(() => {
        if (id) {
            axios.get(`${editAction}?id=${id}`)
                .then((result: AxiosResponse) => {
                    if (result && result.data) {
                        updateData(result.data);
                    }
                });
        }
    }, [id]);

    useEffect(() => {
        if (data) {
            data.boxId = data.Box.Id;
            let dataFormatted = FieldExtractor.extractObjectField(data, '', null, true) as DriverType;
            setFormData(dataFormatted);
        }
    }, [data]);

    useEffect(() => {
        getBoxes();
        getContainerConfigurations();
        console.log(categories)
    }, []);

    const getBoxes = () => {
        axios.post(`${baseAPIUrl}GetBoxes`)
            .then((result: AxiosResponse) => {
                if (result && result.data && result.data.Boxes) {
                    setBoxes(result.data.Boxes);
                }
            })
    }

    const getContainerConfigurations = () => {
        axios.post(`${baseAPIUrl}GetContainerConfigurationList`)
            .then((result: AxiosResponse) => {
                if (result && result.data && result.data.Configurations) {
                    setContainerConfigurations(result.data.Configurations);
                }
            })
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        let { name, value } = event.target;
        name = convertFirstLetterToLowerCase(name);
        let [parentPropName, childPropName] = name.split('.');
        if (childPropName) {
            childPropName = convertFirstLetterToLowerCase(childPropName);
            setFormData((prevFormData: any) => ({
                ...prevFormData,
                [parentPropName]: {
                    ...prevFormData[parentPropName],
                    [childPropName]: value,
                },
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value
            }));
        }
    };


    const redirectBack = () => {
        navigate('/configurations/driver');
    };

    return (
        <React.Fragment>
            <button className="mt-20 back-button" onClick={redirectBack}>Indietro</button>
            <h2 className="page-title mb-20 mt-15">{
                id !== undefined && id !== null ? 'Modifica il driver' : 'Inserisci un nuovo driver'}</h2>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        BoxId
                    </label>
                    <select
                        name="BoxId"
                        value={formData.boxId}
                        className='input-select'
                        required
                        onChange={handleInputChange}
                    >
                        <option value="0" hidden disabled>Seleziona una box</option>
                        {boxes?.map((el) => {
                            return (
                                <option
                                    value={el.Id}
                                    key={`box-${el.Id}`}
                                >{el.BoxName}</option>
                            )
                        })}
                    </select>
                </div>
            </div>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        Categoria
                    </label>
                    <select
                    name="Category"
                    required
                    className='input-select'
                    value={formData.category}
                    onChange={handleInputChange}
                    >
                        <option value="" hidden disabled>Seleziona una categoria</option>
                        {Object.entries(categories).map(([key, value]) => (
                            <option value={value} key={key}>
                                {key}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="input-box">
                    <label className="input-label required">
                        Diverter Number
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="DiverterNumber"
                        required
                        value={formData.diverterNumber}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <h6 className='mb-10 mt-10'>Configuration Driver</h6>
            <div className="input-row">
                <div className="input-box">
                    <label className="input-label">
                        Address
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="ConfigurationDriver.Address"
                        value={formData.configurationDriver.address}
                        onChange={handleInputChange}
                    />

                </div>
                <div className="input-box">
                    <label className="input-label">
                        Port
                    </label>
                    <input
                        className="input-field"
                        type="text"
                        name="ConfigurationDriver.Port"
                        value={formData.configurationDriver.port}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="input-row">
                <div className="input-box">
                    <label className="input-label required">
                        Container Configuration Id
                    </label>
                    <select
                        name="ContainerConfigurationId"
                        value={formData.containerConfigurationId}
                        className='input-select'
                        required
                        onChange={handleInputChange}
                    >
                        <option value="0" hidden disabled>Seleziona una configurazione</option>
                        {containerConfigurations?.map((el: ContainerConfigurationsType) => {
                            return (
                                <option
                                    value={el.Id}
                                    key={`box-${el.Id}`}
                                >{el.Name}</option>
                            )
                        })}
                    </select>
                </div>
            </div>

            <button type="submit" className="submit-button mt-20 mb-40">Salva</button>
        </React.Fragment>
    );
}

export default CreateOrEdit;